<template>
        <video id="videoPlayer"
            ref="videoPlayer"
            :autoplay="autoplay"
            :loop="loop"
            :muted="muted"
            :controls="controls"
            @play="play"
            @pause="pause"
            @seeked="seeked">
            <source :src="video_mp4" type="video/mp4"/>
        <audio ref="audioPlayer"
            aria-role="presentation"
            :autoplay="autoplay"
            :loop="loop"
            :muted="true">
            <source :src="descriptiveAudio" type="audio/wav"/>
        </audio>
        </video>
</template>

<script>
import videojs from 'video.js';

export default {
    name: "VideoPlayer",
    props: {
        autoplay: {
            type: Boolean,
            default: false
        },
        controls: {
            type: Boolean,
            default: false
        },
        loop: {
            type: Boolean,
            default: true
        },
        muted: {
            type: Boolean,
            default: true
        },
        posterframe: String,
        video_mp4: String,
        descriptiveAudio: String,
        descriptiveAudioMuted: Boolean
    },
    data() {
        return {
            playing: false,
            player: null,
            options: {
                autoplay: this.autoplay,
                controls: this.controls,
                loop: this.loop,
                muted: this.muted,
            }
        }
    },
    methods: {
        //not in use, video end() signal is not reliable so this is handy
        checkStatus(){
            if (this.player !== null){
                //console.log(this.player.currentTime());

                if (this.player.currentTime() !== 0){
                    this.playing = true;
                }

                if (this.player.ended() || (this.playing && this.player.currentTime() === 0)){
                    this.$emit("ended");
                    this.playing = false;
                }

                else {
                    setTimeout(() => {
                        this.checkStatus();
                    }, 1000);
                }
            }
        },
        play(){
            this.playing = true; 

            if (this.descriptiveAudio){
                this.$refs.audioPlayer.muted = this.descriptiveAudioMuted;
                this.$refs.audioPlayer.play();
            }
            
        },
        pause(){
            this.playing = false;

            if (this.descriptiveAudio){
                this.$refs.audioPlayer.pause();
            }
        },
        seeked(){
            if (this.descriptiveAudio){
                this.$refs.audioPlayer.muted = this.descriptiveAudioMuted;
                this.$refs.audioPlayer.currentTime = this.$refs.videoPlayer.currentTime;
            }
        }
    },
    watch: {
        descriptiveAudioMuted(value){
            this.$refs.audioPlayer.muted = value;
        }
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}


</script>

